module.exports = __webpack_public_path__ + "img/phone-number-bg.b6235966.png";